const lib = require("./lib");
const {
  ENERGY_BASELINE,
  SCALING_FACTOR,
  RANGE_PROFILES,
  RANGE_PROFILE_KEY,
  LIMITS_PER_KCAL,
} = require("./constant");

/**
 * Calculate score based on a dictionary with amounts for each nutrient
 *
 * @param {array} amounts [{"nutrient": amount}, {}, {}]
 * @returns {number}
 */
module.exports = function ({
  amounts,
  validateNutrition = true,
  scalingFactor = SCALING_FACTOR,
  marketCode = null,
}) {
  // get range profiles specific for the country or default to MMIQv1
  const rangeProfiles =
    RANGE_PROFILES[RANGE_PROFILE_KEY[marketCode] || "default"];
  const requiredFields = rangeProfiles.map((a) => a.name).concat("kcal");
  const totalAmount = lib.sumValues(amounts, requiredFields);
  if (totalAmount.kcal <= 0) throw Error("Value for kcal must be > 0");

  // validate data
  if (validateNutrition) {
    const errors = [];
    if (totalAmount.kcal < 100)
      errors.push("Energy (kcal) must be at least 100 kcals.");
    if (totalAmount.fatSaturatedGrams > totalAmount.fatTotalGrams)
      errors.push(
        "Value for saturated fat cannot be higher than value for total fat."
      );
    for (const [nutrient, upperLimit] of Object.entries(LIMITS_PER_KCAL)) {
      if (nutrient in totalAmount) {
        if (totalAmount[nutrient] / totalAmount.kcal > upperLimit)
          errors.push(`${nutrient} is too high.`);
      }
    }

    if (errors.length > 0) throw Error(errors.join("\n"));
  }

  let score = 0;
  let totalWeight = 0;
  rangeProfiles.forEach((rp) => {
    const amt =
      (parseFloat(totalAmount[rp.name]) * ENERGY_BASELINE) /
      parseFloat(totalAmount.kcal);
    let nutScore = 0;
    if (rp.lhr0 < amt && amt < rp.lhr) {
      nutScore = (amt - rp.lhr0) / (rp.lhr - rp.lhr0);
    } else if (rp.lhr <= amt && amt <= rp.uhr) {
      nutScore = 1;
    } else if (rp.uhr < amt && amt < rp.uhr0) {
      nutScore = (rp.uhr0 - amt) / (rp.uhr0 - rp.uhr);
    }

    score += nutScore * rp.weight;
    totalWeight += rp.weight;
  });

  return lib.scaleRoundTo5((score / totalWeight) * 100, scalingFactor);
};
